/*
  Removes orphaned first-order gift lines from the cart.
  pdp-first-order-gift.js tags the gift line with properties._free_gift_for =
  <main product id>. Whenever the cart changes, if no subscription line for
  that product remains, the gift line is removed automatically.
*/
(function () {
  if (window.FreeGiftGuard) return;
  window.FreeGiftGuard = true;

  var checkOnLoad = document.currentScript && document.currentScript.hasAttribute('data-check-on-load');
  var busy = false;

  function checkCart(cart) {
    if (busy) return;
    if (!cart || !Array.isArray(cart.items)) return;

    var orphans = cart.items.filter(function (item) {
      var giftFor = item.properties && item.properties._free_gift_for;
      if (!giftFor) return false;
      var mainInCart = cart.items.some(function (other) {
        return other !== item && String(other.product_id) === String(giftFor) && other.selling_plan_allocation;
      });
      return !mainInCart;
    });
    if (!orphans.length) return;

    busy = true;

    var updates = {};
    orphans.forEach(function (item) {
      updates[item.key] = 0;
    });

    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );

    var hasFox = window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig;
    var config = hasFox
      ? FoxTheme.utils.fetchConfig()
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    config.body = JSON.stringify({
      updates: updates,
      sections: sections,
      sections_url: window.location.pathname
    });

    var updateUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_update_url) || '/cart/update';

    fetch(updateUrl, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (cartJson) {
        if (!cartJson || cartJson.status || cartJson.errors) return;
        if (window.FoxTheme && FoxTheme.pubsub) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        busy = false;
      });
  }

  function init() {
    if (!(window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS)) return false;

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      checkCart(event && event.cart);
    });

    if (checkOnLoad) {
      // The cart was rendered with a gift line already in it: validate it once on load.
      var cartUrl = (FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
      fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(checkCart)
        .catch(function (error) {
          console.log(error);
        });
    }
    return true;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
